import style from '../CSS/RoundVideoResult.module.css'
import React from "react";

const Comment = ({title}) => {
    return (
        <>
            <div className={style.comment}>
                <p>Comment: {title}</p>
                <span className={style.comment__icon}><i className="fa-solid fa-edit"></i></span>
            </div>
        </>
    );
};

export default Comment;